/**
 * Created with IntelliJ IDEA.
 * User: Gerald
 * Date: 14.06.12
 * Time: 15:15
 * To change this template use File | Settings | File Templates.
 */

import { IAssetManager } from "./IAssetManager";
import { error } from "../logging/error";
import {getDefinitionByName, getDefinitionByNameFromLibrary} from "@goodgamestudios/createjs-utilities";

// import getDefinitionByName = createjs.getDefinitionByName;

export class DefaultAssetManager implements IAssetManager {
    constructor() {
    }

    /**
     * calls getDefinition, but catches any error and returns only true
     * if no error occurred
     *
     * @param identifier a class-name as a String
     * @return true when you able to call getDefinition without Errors
     */
    public doesExist(identifier: Object): boolean {
        try {
            this.getDefinition(identifier);
        }
        catch (error) {
            return false;
        }

        return true;
    }

    /**
     * uses getDefinitionByName
     *
     * @param identifier a class-name as a String
     * @return a Class-Object
     */
    public getDefinition(identifier: Object): Object {
        let objDef: Object;

        try {
            objDef = getDefinitionByNameFromLibrary(String(identifier));
          //  objDef = getDefinitionByName(String(identifier));
        }
        catch (e) {
            error(`error: {e}.\nidentifier: ${identifier}`);
        }

        return objDef;
    }

    /**
     * uses getDefinition, but enforces stricter typing
     *
     * @param name a class-name
     * @return a Class-Object
     */
    public getClass(name: string): Object {
        return (<Object>this.getDefinition(name));
    }

}
